'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _changePassword = require('./changePassword.html');

var _changePassword2 = _interopRequireDefault(_changePassword);

var _groupInvite = require('./groupInvite.html');

var _groupInvite2 = _interopRequireDefault(_groupInvite);

var _userActivation = require('./userActivation.html');

var _userActivation2 = _interopRequireDefault(_userActivation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extrasConfig = function extrasConfig($stateProvider) {
    $stateProvider.state('changePassword', {
        url: '/reset/change?token',
        template: _changePassword2.default,
        controller: 'changePasswordController',
        controllerAs: 'changePassword'
    }).state('groupInvitation', {
        url: '/groupInvitation?token',
        template: _groupInvite2.default,
        controller: 'groupInviteController',
        controllerAs: 'groupInvite'
    }).state('userActivation', {
        url: '/user/activate?token',
        template: _userActivation2.default,
        controller: 'userActivationController',
        controllerAs: 'userActivation'
    });
};

exports.default = extrasConfig;


/** WEBPACK FOOTER **
 ** ./src/app/components/extras/extras.config.js
 **/